module.exports = __webpack_public_path__ + "img/Graph3_7days_green.03d6c2e0.png";